import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { NextActionCompleteKYC } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/CompleteKYC/NextActionCompleteKYC';
import { NextActionCompleteOnboarding } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/CompleteOnboarding/NextActionCompleteOnboarding';
import { NoLenderRequestId } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/NoLenderRequestId/NoLenderRequestId';
import { NextActionSignContract } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/NextActionSignContract';
import { NextActionUploadDocuments } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/NextActionUploadDocuments';

export interface NextActionFactoryProps {
  action: Action;
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
  onOpenMerchantPos: () => void;
}

// TODO: Separate actions into components
export const NextActionFactory = ({
  action,
  paymentMethodDetailEntity,
  onOpenMerchantPos,
}: NextActionFactoryProps) => {
  if (action === Action.COMPLETE_ONBOARDING) {
    return (
      <NextActionCompleteOnboarding
        paymentMethodDetailEntity={paymentMethodDetailEntity}
        onOpenMerchantPos={onOpenMerchantPos}
      />
    );
  }

  if (action === Action.NO_LENDER_REQUEST_ID) {
    return <NoLenderRequestId paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.UPLOAD_DOCUMENTS) {
    return <NextActionUploadDocuments paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.SIGN_CONTRACT || action === Action.COMPLETE_PROCESS_SANTANDER) {
    return <NextActionSignContract paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.COMPLETE_KYC) {
    return <NextActionCompleteKYC paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  return null;
};
